"use client";
import * as Slider from "@radix-ui/react-slider";
import { useState, useReducer, createContext, useContext, Suspense, useEffect } from "react";
import styles from "./shop.module.css";
import useSWR from "swr";
import useSWRInfinite from "swr/infinite";
import { basicFetcher } from "utils/fetcher";
import Link from "next/link";
import dynamic from "next/dynamic";
import * as Dialog from "@radix-ui/react-dialog";
import { FiFilter } from "react-icons/fi";
import Empty from "component/empty";
// import DOMPurify from "dompurify";
import DOMPurify from "isomorphic-dompurify";
import ProductCard from "component/productCard";

const ResetShop = dynamic(() => import("./clie").then(({ ResetShop }) => ResetShop), { ssr: false });

export default function SliderTest() {
  const [value, setValue] = useState([6_000, 10_000_000]);
  const [_, dispatch] = useShopContext();
  return (
    <>
      <p>
        Price Range (₦){" "}
        <button
          style={{
            color: "var(--chateau-green)",
            float: "right",
          }}
          onClick={() => {
            dispatch({
              type: "updateMin_priceTo",
              payload: value[0],
            });
            dispatch({
              type: "updateMax_priceTo",
              payload: value[1],
            });
          }}
          type="button">
          Apply
        </button>
      </p>
      <Slider.Root
        className={styles.SliderRoot}
        value={value}
        onValueChange={setValue}
        step={1_000}
        min={6000}
        max={10_000_000}>
        <Slider.Track className={styles.SliderTrack}>
          <Slider.Range className={styles.SliderRange} />
        </Slider.Track>
        <Slider.Thumb className={styles.SliderThumb} />
        <Slider.Thumb className={styles.SliderThumb} />
      </Slider.Root>
      <div className={styles.pricegroup}>
        <label className={styles.label}>
          <input
            step={1_000}
            min={6000}
            max={10_000_000}
            type="number"
            value={value[0]}
            onChange={(e) => {
              setValue((value) => [e.target.valueAsNumber, value[1]]);
            }}
          />
          <span>Min. Price</span>
        </label>
        <label className={styles.label}>
          <input
            onChange={(e) => {
              setValue((value) => [value[0], e.target.valueAsNumber]);
            }}
            step={1_000}
            min={value[0] || 6000}
            max={10_000_000}
            type="number"
            value={value[1]}
          />
          <span>Max. Price</span>
        </label>
      </div>
    </>
  );
}
export { SWRConfig } from "swr";

const initialState = {
  min_price: undefined as number | undefined,
  max_price: undefined as number | undefined,
  category: "",
  name: "",
  location: "",
};

function transformToserlizable(data: Record<string, any>) {
  const tbR: Record<string, string> = {
    limit: "12",
  };

  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const value = data[key];
      if (undefined == value || value === "") {
        continue;
      } else {
        tbR[key] = String(value);
      }
    }
  }

  return tbR;
}

type K = typeof initialState;

type UpdateByIfNumber<T extends keyof O, O = K> = O[T] extends number ? `update${Capitalize<T & string>}By` : never;

type UpdateBy<O = K> = {
  [Key in keyof O as UpdateByIfNumber<Key & keyof O, O>]: (state: O, value: O[Key]) => Partial<O>;
};

type UpdateTo<O = K> = {
  [Key in keyof O as `update${Capitalize<Key & string>}To`]: (state: O, value: O[Key]) => Partial<O>;
};

type Actions = UpdateBy<K> & UpdateTo<K>;

let actions: Actions = {
  updateNameTo(state, value) {
    return {
      name: value,
    };
  },
  updateCategoryTo(state, value) {
    return {
      category: value,
    };
  },
  updateMin_priceTo(state, value) {
    // if (value && (!isNaN(value) || value < 0)) {
    //   return state;
    // }
    if(!value || isNaN(value)){
      return state;
    }

    return {
      min_price: value,
    };
  },
  updateMax_priceTo(state, value) {
    // if (value && (!isNaN(value) || (state.min_price && value < state.min_price))) {
    //   return state;
    // }
    if(!value || isNaN(value)){
      return state;
    }

    return {
      max_price: value,
    };
  },
  updateLocationTo(state, value) {
    return {
      location: value,
    };
  },
};

function reducer<T extends keyof Actions>(
  state: K,
  action: {
    type: T;
    payload: Actions[T] extends (state: K, value: infer P) => Partial<K> ? P : never;
  }
) {
  // @ts-ignore
  const newS = Object.assign({}, state, actions[action.type](state, action.payload));

  // const searchParams = new URLSearchParams(transformToserlizable(newS));
  // console.log(searchParams.toString());
  return newS;
}

let _context:
  | [
      K,
      <T extends keyof Actions>(data: {
        type: T;
        payload: Actions[T] extends (state: K, value: infer P) => Partial<K> ? P : never;
      }) => void
    ]
  | undefined = undefined;

const ShopContext = createContext(_context!);

export function ShopProvider({ children }: React.PropsWithChildren) {
  const shop = useReducer(reducer, initialState);

  return (
    <>
      {/* @ts-ignore */}
      <ShopContext.Provider value={shop}>{children}</ShopContext.Provider>
      <Suspense>
        <ResetShop dispatch={shop[1]} />
      </Suspense>
    </>
  );
}

export function useShopContext() {
  return useContext(ShopContext);
}

export function CategorySelect() {
  const { data: categories = [] } = useSWR<Category[]>("categories/", basicFetcher);
  const [data, dispatch] = useShopContext();
  return (
    <fieldset>
      <legend>
        Categories{" "}
        <button
          type="button"
          onClick={() => {
            dispatch({
              type: "updateCategoryTo",
              payload: "",
            });
          }}>
          reset
        </button>
      </legend>
      {categories.map((category, i) => (
        <div className={styles.radio} key={category.name}>
          <input
            checked={data.category === category.name}
            onChange={() => {
              dispatch({
                type: "updateCategoryTo",
                payload: category.name,
              });
            }}
            className="sr-only"
            type="radio"
            name="category"
            id={`category-${i}`}
          />
          <label className={styles.label} htmlFor={`category-${i}`}>
            <img src={`${DOMPurify.sanitize(category.name)}.svg`} alt={category.name} height={21} />
            {DOMPurify.sanitize(category.name)}
          </label>
        </div>
      ))}
    </fieldset>
  );
}
export function NameSearch() {
  const [data, dispatch] = useShopContext();
  return (
    <fieldset className={styles.form}>
        <section className={styles.label} >
          <input
            onChange={(e) => {
              if (e.target.value === data.name || e.target.value.length < 2) return;
              dispatch({
                type: "updateNameTo",
                payload: e.target.value,
              });
            }}
            className=""
            placeholder="Search by product name"
            type="text"
            name="name"
            id={`nameSearch`}
            />
        </section> 

    </fieldset>
  );
}


export function LocationSelect() {
  const { data: locations = [] } = useSWR<Category[]>("locations/", basicFetcher);
  const [_, dispatch] = useShopContext();

  return (
    <section>
      <label className={styles.label}>
        <span>Ships to</span>
        <select
          onChange={(e) => {
            dispatch({
              type: "updateLocationTo",
              payload: e.target.value,
            });
          }}
        >
          <option value="">All</option>
          {locations.map((state) => (
            <option value={state.id} key={state.id}>
              {state.name}
            </option>
          ))}
        </select>
      </label>
      {/* <div className={styles.btns}>
        <button className="btn btn-lg btn-white" type="reset">
          Clear Filter
        </button>
        <button className="btn btn-lg btn-green" type="submit">
          Apply
        </button>
      </div> */}
    </section>
  );
}

export function Products() {
  const [shop] = useShopContext();
  const search = transformToserlizable(shop);
  const searchParams = new URLSearchParams(search);
  const {
    data: paginatedData,
    isLoading,
    setSize,
    size,
  } = useSWRInfinite<Paginated<Product>>((index) => `products/?${searchParams}&offset=${index * 12}`, basicFetcher);

  // useEffect(() => {
  //   setSize(0);
  // }, [setSize, searchParams]);
  // setSize(1);

  const products =
    paginatedData?.reduce((acc, data) => {
      acc.push(...data.results);
      return acc;
    }, [] as Product[]) || [];
  const isLoadingMore = isLoading || (size > 0 && paginatedData && typeof paginatedData[size - 1] === "undefined");
  const hasNext = Boolean(paginatedData?.[paginatedData.length - 1]?.next);
  // const isEmpty = paginatedData?.[0]?.results.length === 0;
  // const isReachingEnd = isEmpty || (paginatedData && paginatedData[paginatedData.length - 1]?.results.length < 12);
  useEffect(() => {
    const target = document.querySelector("#result + *");

    const observer = new IntersectionObserver((entries) => {
      // Loop through the entries

      entries.forEach((entry) => {
        if (entry.isIntersecting && hasNext && !isLoadingMore) {
          setSize((_size) => _size + 1);
        }
        // console.log(entry);
      });
    });

    // Observe the target element
    observer.observe(target!);
    return () => {
      observer.disconnect();
    };
  }, [hasNext, isLoadingMore, setSize]);
  return (
    <>
      <ul className={styles.products}>
        {products.map((product) => (
          // <li key={product.id}>
          //   <Link href={`/product/${product.id}`} prefetch={false}>
          //     <div className={styles.productImage}>
          //       <img src={DOMPurify.sanitize(product.primary_img_url)} alt={product.name} />
          //     </div>
          //     <h3>{DOMPurify.sanitize(product.name)}</h3>
          //     <h2>₦{DOMPurify.sanitize((product.price + (product.installation_fee || 0)).toLocaleString())}</h2>
          //   </Link>
          // </li>
          <ProductCard key={product.id} product={{ ...product, images: [DOMPurify.sanitize(product.primary_img_url)] }} round showCategory />
        ))}
        {isLoadingMore &&
          Array(12)
            .fill(null)
            .map((_, i) => {
              return <li key={i} className="pulse" data-pulse></li>;
            })}
      </ul>
      {!isLoadingMore && !products?.length && (
        <Empty heading="There are no products for this filter" body="Try other filters" />
      )}
    </>
  );
}

export function RenderFilterModal({ children }: React.PropsWithChildren) {
  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>
        <button className="btn btn-white">
          Filter <FiFilter />
        </button>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.overlay} />
        <Dialog.Content className={styles.content}>{children}</Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
